import {inject} from '@angular/core';
import {CanMatchFn, Route, Router, UrlSegment} from '@angular/router';
import {NEVER} from 'rxjs';
import {environment} from '../../environments/environment';

export const MediaBlastRedirectGuard: CanMatchFn = (_route: Route, segments: UrlSegment[]) => {
  const router = inject(Router);
  const path = segments.map(s => s.toString()).join('/');

  const nav = router.getCurrentNavigation();
  const targetTree = nav?.finalUrl ?? nav?.extractedUrl;

  let search = '';
  let hash = '';
  if (targetTree) {
    const qp = targetTree.queryParams;
    const qs = Object.keys(qp).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(qp[k])}`).join('&');
    search = qs ? `?${qs}` : '';
    hash = targetTree.fragment ? `#${targetTree.fragment}` : '';
  } else {
    search = window.location.search;
    hash = window.location.hash;
  }

  const target = new URL(`${environment.mbRedirectUrl}/${path}${search}${hash}`);
  if (target.host === window.location.host) {
    // Guards against this file ever running on the mb.adcore.com repo itself
    // (same routes, path-for-path identical) — would otherwise self-redirect infinitely.
    return true;
  }

  showRedirectNotice();
  setTimeout(() => window.location.href = target.toString(), 2000);
  return NEVER;
};

function showRedirectNotice(): void {
  document.body.innerHTML = `
    <div style="display:flex;align-items:center;justify-content:center;height:100vh;
      font-family:Roboto,Arial,sans-serif;text-align:center;padding:24px;">
      <div>
        <div style="font-size:18px;color:#333;margin-bottom:8px;">
          Media Blast has moved to a new website. Redirecting you now&hellip;
        </div>
        <div style="font-size:14px;color:#888;">
          If you are not redirected automatically, please refresh the page.
        </div>
      </div>
    </div>`;
}
